import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ResponsiveService {
  readonly isSmallScreen = toSignal(
    this.breakpointObserver.observe('(max-width: 509px)').pipe(map(r => r.matches)),
    { initialValue: false }
  );

  constructor(private readonly breakpointObserver: BreakpointObserver) {}
}
